import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined";

// import JS files
import useFetch from "../../../../context/useFetch";
import MuiModal from "../../../shares/MuiModal";
import MuiUpload from "../../../shares/MuiUpload";
import MuiButton from "../../../shares/MuiButton";
import RemoveModal from "../../../shares/RemoveModal";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiSelectHook from "../../../shares/MuiSelectHook";
import MuiAccordion from "../../../shares/MuiAccordion";
import MuiComboBox from "../../../shares/MuiComboBox";
import RingsSizeEdit from "./RingsSizeEdit";
import { ageList, colorList, fixNumbers } from "../../../../utils";
import RingsSizeShow from "../../../shares/RingsSizeShow";
import ProducersShowModal from "./ProducersShowModal";

// import Others files

const AddRing = (props) => {
  let windowWidth = window.screen.width;

  const [selectedItemShow, setSelectedItemShow] = useState();

  const [openRingsSizeShowModal, setOpenRingsSizeShowModal] = useState(false);
  const [openProducersShowModal, setOpenProducersShowModal] = useState(false);

  const handleRingsSizeShowModal = (item) => {
    setSelectedItemShow(item);
    setOpenRingsSizeShowModal((before) => !before);
  };

  const handleProducersShowModal = (item) => {
    setSelectedItemShow(item);
    setOpenProducersShowModal((before) => !before);
  };

  const [openRemoveRingModal, setOpenRemoveRingModal] = useState(false);
  const handleRemoveRingModal = () => {
    setOpenRemoveRingModal((before) => !before);
  };

  const [isEdit, setIsEdit] = useState(false);
  const [selectedRingIndex, setSelectedRingIndex] = useState();
  const [imageFile, setImageFile] = useState(undefined);
  const [createdRingsList, setCreatedRingsList] = useState([]);
  const [postValues, setPostValues] = useState();
  const [selectedProducer, setSelectedProducer] = useState(undefined);
  const [selectedProducersList, setSelectedProducersList] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      brand: "",
      code: "",
      age: "",
      color: "",
      weight1: "0.0",
      weight2: "0.0",
      weight3: "0.0",
      weight4: "0.0",
      weight5: "0.0",
      weight6: "0.0",
    },
  });

  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const AddRingApi = useFetch({
    method: "post",
    url: "Bangle_Service",
    trigger: false,
    data: postValues,
    caller: props.getFunc,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      reset();
      setCreatedRingsList([]);
      // toast.success("النگو موردنظر با موفقیت ایجاد شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handlePostValues = () => {
    let formData = new FormData();

    for (let index = 0; index < createdRingsList.length; index++) {
      let providersList = [];
      createdRingsList[index].provider.filter((item) => {
        providersList.push(item.id);
      });

      formData.append("name", createdRingsList[index].name);
      formData.append("brand", createdRingsList[index].brand);
      if (createdRingsList[index].img !== undefined)
        formData.append(
          "img",
          createdRingsList[index].img,
          createdRingsList[index].img.name
        );
        else
        formData.append(
          "img",
          "EMPTY"
        );
      formData.append("code", fixNumbers(createdRingsList[index].code));
      formData.append("age", createdRingsList[index].age);
      formData.append("color", createdRingsList[index].color);
      for (var i = 0; i < providersList.length; i++) {
        formData.append("provider", providersList[i]);
      }
      formData.append("provider_num", providersList.length);
      formData.append("weight1", createdRingsList[index].weight1);
      formData.append("weight2", createdRingsList[index].weight2);
      formData.append("weight3", createdRingsList[index].weight3);
      formData.append("weight4", createdRingsList[index].weight4);
      formData.append("weight5", createdRingsList[index].weight5);
      formData.append("weight6", createdRingsList[index].weight6);
    }
    setPostValues(formData);
    AddRingApi.reFetch();
  };

  const onSubmit = (data) => {
    if (imageFile !== undefined) {
      data["img"] = imageFile;
    }
    data["provider"] = selectedProducersList;
    if (isEdit) {
      let beforeCreatedRingsList = [...createdRingsList];
      beforeCreatedRingsList[selectedRingIndex] = data;
      setCreatedRingsList(beforeCreatedRingsList);
    } else {
      setCreatedRingsList([...createdRingsList, data]);
    }
    reset({
      code: "",
      age: "",
      color: "",
      weight1: data.weight1,
      weight2: data.weight2,
      weight3: data.weight3,
      weight4: data.weight4,
      weight5: data.weight5,
      weight6: data.weight6,
    });
    setImageFile(undefined);
    setValue("name", data.name);
    setValue("brand", data.brand);
    // setSelectedProducersList([]);
    // setSelectedProducer(undefined);
    setIsEdit(false);
  };

  const handleEdit = (index) => {
    setValue("name", createdRingsList[index].name);
    setValue("brand", createdRingsList[index].brand);
    setValue("code", createdRingsList[index].code);
    setValue("age", createdRingsList[index].age);
    setValue("color", createdRingsList[index].color);
    setValue("weight1", createdRingsList[index].weight1);
    setValue("weight2", createdRingsList[index].weight2);
    setValue("weight3", createdRingsList[index].weight3);
    setValue("weight4", createdRingsList[index].weight4);
    setValue("weight5", createdRingsList[index].weight5);
    setValue("weight6", createdRingsList[index].weight6);
    setSelectedProducersList(createdRingsList[index].provider);
    setSelectedRingIndex(index);
    setImageFile(createdRingsList[index].img);
    setIsEdit(true);
  };

  const handleRemove = (index) => {
    let beforeCreatedRingsList = [...createdRingsList];
    beforeCreatedRingsList.splice(index, 1);
    setCreatedRingsList(beforeCreatedRingsList);
    setOpenRemoveRingModal(false);
  };

  const [searchedProducerText, setSearchedProducerText] = useState("");
  const [producersList, setProducersList] = useState({
    results: [],
  });

  const getProvidersApi = useFetch({
    method: "get",
    url: "Provider_Service",
    params: { name: searchedProducerText },
    trigger: false,
    argFunc: (res) => {
      setProducersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطا در برقراری ارتباط با سرور", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleSearchedProducerText = (text) => {
    setSearchedProducerText(text);
    if (text.length >= 1) {
      getProvidersApi.reFetch();
    }
  };

  const handleSelectedProducersList = () => {
    if (
      selectedProducersList.filter((ite) => ite.id == selectedProducer)
        .length == 0
    ) {
      setSelectedProducersList([
        ...selectedProducersList,
        producersList.results.filter((it) => it.id == selectedProducer)[0],
      ]);
      setSelectedProducer(undefined);
      setProducersList({ results: [] });
    }
  };

  const removeSelectedProducersList = (id) => {
    setSelectedProducersList(
      selectedProducersList.filter((it) => it.id !== id)
    );
    setSelectedProducer(undefined);
  };

  return (
    <>
      {openRingsSizeShowModal && (
        <MuiModal
          openModal={openRingsSizeShowModal}
          setOpenModal={setOpenRingsSizeShowModal}
          width="w-3/5"
        >
          <RingsSizeShow
            code={selectedItemShow.code}
            gender={selectedItemShow.age}
            color={selectedItemShow.color}
            w1={selectedItemShow?.weight1}
            w2={selectedItemShow?.weight2}
            w3={selectedItemShow.weight3}
            w4={selectedItemShow.weight4}
            w5={selectedItemShow.weight5}
            w6={selectedItemShow.weight6}
            dontShowNamdAndBrand
          />
        </MuiModal>
      )}
      {openProducersShowModal && (
        <MuiModal
          openModal={openProducersShowModal}
          setOpenModal={setOpenProducersShowModal}
          width="w-2/5"
        >
          <ProducersShowModal selectedItem={selectedItemShow} />
        </MuiModal>
      )}

      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <div className="grid md:grid-cols-3 gap-x-2 mt-4">
            <div className="border p-4 md:col-span-2 rounded-md">
              <form className="" onSubmit={handleSubmit(onSubmit)}>
                <div className="grid md:grid-cols-2 gap-y-6 gap-x-4 border-dashed border-b pb-4">
                  <div className="">
                    <MuiTextFieldHook
                      id="outlined-basic"
                      label="نام"
                      variant="outlined"
                      size="small"
                      name="name"
                      control={control}
                      register={{
                        required: {
                          value: true,
                          message: "نام را وارد کنید.",
                        },
                      }}
                    />
                  </div>

                  <div>
                    <MuiSelectHook
                      size="small"
                      inputLabel="برند"
                      label="Brand"
                      control={control}
                      name="brand"
                      register={{
                        required: {
                          value: true,
                          message: "برند را انتخاب کنید",
                        },
                      }}
                      labelId="brand-label"
                      id="brand-select"
                      menuItems={brandsList.results}
                      fromApi={true}
                    />
                  </div>
                </div>
                <div className=" rounded-md grid md:grid-cols-2">
                  <div className="">
                    <div className="mt-2 flex justify-center">
                      {imageFile instanceof File ? (
                        <img
                          className="w-32 h-32 rounded-full"
                          src={URL.createObjectURL(imageFile)}
                        />
                      ) : (
                        <BrokenImageOutlinedIcon
                          sx={{ fontSize: "6rem", color: "#adb5bd" }}
                        />
                      )}
                    </div>
                    <div className="mt-4">
                      <MuiUpload setImageFile={setImageFile} />
                    </div>
                    <div className="mt-6">
                      <MuiTextFieldHook
                        id="outlined-basic"
                        label="کد"
                        variant="outlined"
                        size="small"
                        name="code"
                        control={control}
                        isLTR={true}
                        register={{
                          required: {
                            value: true,
                            message: "کد را وارد کنید.",
                          },
                        }}
                      />
                    </div>
                    <div className="mt-6">
                      <MuiSelectHook
                        size="small"
                        inputLabel="سن"
                        label="Age"
                        control={control}
                        name="age"
                        register={{
                          required: {
                            value: true,
                            message: "سن را انتخاب کنید",
                          },
                        }}
                        labelId="woman-girl-label"
                        id="woman-girl-select"
                        menuItems={ageList}
                        fromApi={false}
                      />
                    </div>
                    <div className="mt-6">
                      <MuiSelectHook
                        size="small"
                        inputLabel="رنگ"
                        label="Color"
                        control={control}
                        name="color"
                        register={{
                          required: {
                            value: true,
                            message: "رنگ را انتخاب کنید",
                          },
                        }}
                        labelId="color-label"
                        id="color-select"
                        menuItems={colorList}
                        fromApi={false}
                      />
                    </div>
                  </div>
                  <div className="">
                    <div className="mt-4">
                      <RingsSizeEdit
                        control={control}
                        register={{
                          required: {
                            value: false,
                            message: "وزن را وارد کنید.",
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="border-b border-dashed mt-4"></div>
                <div className="grid md:grid-cols-4 gap-x-4 items-center mt-4">
                  <span className="md:col-span-2 text-sm md:text-base ">
                    تولیدکنندگانی که این النگو را تولید می‌کنند:
                  </span>

                  <div className="mt-2 md:mb-0 ">
                    <MuiComboBox
                      size="small"
                      label="تولیدکننده"
                      forUser
                      name="provider"
                      labelId="provider-search-label"
                      id="provider-search-select"
                      options={producersList.results}
                      placeholder="تولیدکننده"
                      setSelectedOption={(d) => {
                        setSelectedProducer(d);
                      }}
                      setSearchText={handleSearchedProducerText}
                    />
                  </div>
                  <div className="mt-2 md:mb-0 text-center md:text-left">
                    <MuiButton
                      onClick={handleSelectedProducersList}
                      variant="contained"
                      color="primary"
                      text="افزودن به لیست"
                      disabled={selectedProducer == undefined}
                    />
                  </div>
                </div>
                {selectedProducersList.length > 0 && (
                  <div className="p-2 border mt-2 bg-gray-100 rounded-lg flex flex-wrap">
                    {selectedProducersList.map((item, index) => {
                      return [
                        <div className="bg-white rounded-lg py-1 px-2 m-2">
                          <span>{item.name}</span>
                          <CloseIcon
                            onClick={() => removeSelectedProducersList(item.id)}
                            className="delete-icon mr-2"
                          />
                        </div>,
                      ];
                    })}
                  </div>
                )}
                <div className=" flex justify-end w-full mt-8">
                  <MuiButton
                    withoutOnClick
                    type="submit"
                    variant="contained"
                    icon={isEdit ? <EditIcon /> : <AddIcon />}
                    color="primary"
                    text={isEdit ? "ویرایش" : "افزودن"}
                    disabled={
                      // (imageFile == undefined) |
                      selectedProducersList <= 0
                    }
                  />
                </div>
              </form>
            </div>
            {createdRingsList.length <= 0 && (
              <div className="border  flex flex-col  justify-center col-span-1 rounded-md px-2">
                <div className="mt-4">
                  <div className="w-full flex flex-col items-center justify-center text-gray-400">
                    <PlaylistAddIcon sx={{ fontSize: "300%" }} />
                    <p className="mt-4 text-sm md:text-base ">
                      هنوز النگوی جدیدی اضافه نکرده‌اید.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {createdRingsList.length > 0 && (
              <div className="border col-span-1 rounded-md px-2 pb-4 overflow-scroll max-h-96">
                {createdRingsList.map((item, index) => {
                  return [
                    <div className="mt-4">
                      <MuiAccordion
                        expandedId={index}
                        header={`کد: ${item.code}`}
                      >
                        <div className="flex items-center justify-between">
                          {item.img !== undefined && (
                            <img
                              className="w-8 md:w-12 h-8 md:h-12 rounded-full"
                              src={URL.createObjectURL(item.img)}
                            />
                          )}
                          <span className="show-value">
                            {item.age == "woman" ? "زنانه" : "بچگانه"}
                          </span>
                          <span className="show-value">
                            {item.color == "yellow" ? "زرد" : "سفید"}
                          </span>
                          <MuiButton
                            onClick={() => handleProducersShowModal(item)}
                            variant="outlined"
                            color="primary"
                            text="تولیدکنندگان"
                            size="small"
                          />
                          <MuiButton
                            onClick={() => handleRingsSizeShowModal(item)}
                            variant="outlined"
                            color="secondary"
                            text="وزن‌ها"
                            size="small"
                          />
                        </div>
                        <div className="flex  justify-between mt-6">
                          <div
                            className="edit-icon"
                            onClick={() => handleEdit(index)}
                          >
                            <EditIcon />
                          </div>
                          <div
                            className="delete-icon"
                            onClick={() => handleRemoveRingModal()}
                          >
                            <DeleteIcon />
                          </div>
                          {openRemoveRingModal && (
                            <RemoveModal
                              openModal={openRemoveRingModal}
                              setOpenModal={setOpenRemoveRingModal}
                              onClick={() => handleRemove(index)}
                              text="آیا از حذف النگوی موردنظر اطمینان دارید؟"
                            />
                          )}
                        </div>
                      </MuiAccordion>{" "}
                    </div>,
                  ];
                })}
              </div>
            )}
          </div>

          <div className="flex justify-end mt-4">
            <MuiButton
              onClick={handlePostValues}
              variant="contained"
              color="success"
              text="ایجاد"
              disabled={
                (createdRingsList.length <= 0) | AddRingApi.loading
                  ? true
                  : false
              }
            />
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default AddRing;
